const AGENCY_PROFESSIONAL_ERROR_CODES = {
	SUCCESS: 'SUCCESS',
	CONTACT_US: 'CONTACT_US',
	ALREADY_EXISTS: 'ALREADY_EXISTS'
};

const FLEX_PROFESSIONAL_ERROR_CODES = {
	SUCCESS: 'SUCCESS',
	CONTACT_US: 'CONTACT_US',
	ALREADY_EXISTS: 'ALREADY_EXISTS'
};

export const ERROR_CODES = {
	AGENCY_PROFESSIONAL_ERROR_CODES,
	FLEX_PROFESSIONAL_ERROR_CODES,
	FACILITY_NOT_PERMITTED: 'FACILITY_NOT_PERMITTED',
	ACTIVE_FACILITY_CHANGE_FAILED: 'ACTIVE_FACILITY_CHANGE_FAILED'
};

export default { ERROR_CODES };
